(() => {
  function quote(data, input) {
    const weight = Number(input.weight);
    if (!Number.isFinite(weight) || weight < 0.1 || weight > 100) return {status: 'invalid_weight'};
    if (!input.origin) return {status: 'missing_origin'};
    const route = data?.origins?.[input.origin];
    if (!route || !Array.isArray(data.weights) || !Array.isArray(data.prices)) return {status: 'unavailable'};
    let group = route.groups[0];
    if (route.groups.length > 1) {
      const postal = String(input.postalCode || '').trim();
      if (!postal) return {status: 'missing_postcode'};
      const valid = input.origin === 'CN' ? /^[1-9]\d{5}$/.test(postal) : /^\d{5}(-\d{4})?$/.test(postal);
      if (!valid) return {status: 'invalid_postcode'};
      const number = Number(postal.slice(0, input.origin === 'CN' ? 6 : 5));
      if (input.origin === 'US' && (number < 1000 || number >= 96900 && number <= 96999)) return {status: 'manual_postcode'};
      group = route.groups.find(g => g.ranges.some(([lo, hi]) => number >= lo && number <= hi)) || route.groups.find(g => g.fallback);
    }
    const index = data.weights.findIndex(upper => upper >= weight - 1e-9);
    const price = group && data.prices[group.priceId]?.[index];
    if (!Number.isFinite(price) || price <= 0 || index < 0) return {status: 'unavailable'};
    return {status: 'ok', price, chargeableWeight: data.weights[index], partial: route.partial, fuelPercent: data.fuelPercent, validFrom: null, validTo: null};
  }
  window.HKGImportPricing = {quote};
})();
